export function rng(min, max) {
  return Math.random() * (max - min) + min;
}
  